// src/components/ui/toaster.tsx (or your path)

"use client"; // Add if not present, for hooks like useLocation if this becomes part of a server component tree in Next.js someday (though for React Router it's fine)

import { useToast } from "@/components/hooks/use-toast"; // Assuming this is your custom hook path
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"; // Your actual toast component definitions

// ADDED for React Router
import { useLocation } from "react-router-dom";
import React from "react"; // Ensure React is imported if not already

export function Toaster() {
  const { toasts } = useToast();

  // ADDED: Get current location for React Router
  const location = useLocation();

  return (
    // ADDED: key={location.pathname} to ToastProvider
    // This will remount the ToastProvider when the route (pathname) changes,
    // effectively clearing any existing toasts.
    <ToastProvider key={location.pathname} duration={5000}> {/* Default duration for toasts can be set here */}
      {toasts.map(function ({ id, title, description, action, ...props }) {
        // Individual toasts can override the provider's duration via their `duration` prop,
        // which is passed in through `...props` from the `toast()` call.
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose /> {/* This allows manual closing of each toast */}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}